// Buffer in-memory des événements d'authentification, pour debug côté UI.
// Visible via le panneau dans AuthCallback ou /debug/auth quand un bug
// d'auth survient et que la console JS n'est pas accessible (WebKit Inspector
// indisponible, etc.).

export interface AuthDebugEvent {
  ts: string; // ISO
  level: "info" | "warn";
  message: string;
  details?: unknown;
}

const MAX_EVENTS = 100;
const buffer: AuthDebugEvent[] = [];
const subscribers = new Set<() => void>();

export function logAuth(level: "info" | "warn", message: string, details?: unknown): void {
  const event: AuthDebugEvent = {
    ts: new Date().toISOString(),
    level,
    message,
    details,
  };
  buffer.push(event);
  if (buffer.length > MAX_EVENTS) buffer.shift();
  // Garde aussi un console.* pour le cas où l'inspecteur fonctionne
  const fn = level === "warn" ? console.warn : console.info;
  if (details !== undefined) fn(`[auth] ${message}`, details);
  else fn(`[auth] ${message}`);
  for (const sub of subscribers) sub();
}

export function getAuthDebugLog(): readonly AuthDebugEvent[] {
  return buffer;
}

export function subscribeAuthDebugLog(callback: () => void): () => void {
  subscribers.add(callback);
  return () => subscribers.delete(callback);
}

export function formatAuthDebugLog(): string {
  return buffer
    .map((e) => {
      const detailsStr =
        e.details !== undefined
          ? ` ${typeof e.details === "string" ? e.details : JSON.stringify(e.details)}`
          : "";
      return `${e.ts} [${e.level}] ${e.message}${detailsStr}`;
    })
    .join("\n");
}
